/* MR Mouldings — cart drawer behaviour (see sections/cart-drawer.liquid) */
(function () {
  'use strict';
  var root = document.querySelector('[data-cart-drawer]');
  if (!root) return;
  var sectionId = root.getAttribute('data-section-id') || 'cart-drawer';
  var panel = root.querySelector('[data-cart-drawer-panel]');
  var isCartPage = document.body.classList.contains('template-cart');
  var openOnAdd = root.getAttribute('data-open-on-add') === 'true';
  var openFromHeader = root.getAttribute('data-open-from-header') === 'true';
  var lastFocus = null;
  var selfUpdate = false;
  var rendering = null;
  var renderAgain = false;
  var retryTimer = null;
  var retries = 0;

  document.body.classList.add('mr-drawer-enabled');

  /* ---------- helpers ---------- */
  function addWorkingDays(base, n) {
    var d = new Date(base), c = 0;
    while (c < n) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0 && d.getDay() !== 6) c++; }
    return d;
  }
  function fmt(d) { return d.toLocaleDateString('en-GB', { weekday: 'short', day: 'numeric', month: 'short' }).replace(/Sept\b/, 'Sep'); }

  function enhance() {
    var delivery = root.querySelector('[data-mr-delivery][data-show-dates]');
    if (delivery) {
      var h = delivery.querySelector('[data-mr-delivery-heading]');
      var minD = parseInt(delivery.getAttribute('data-min-days'), 10) || 5;
      var maxD = parseInt(delivery.getAttribute('data-max-days'), 10) || 7;
      if (h) { var now = new Date(); h.textContent = fmt(addWorkingDays(now, minD)) + ' – ' + fmt(addWorkingDays(now, maxD)); }
    }
    var yotpo = root.querySelector('[data-mr-yotpo]');
    if (yotpo) {
      var key = yotpo.getAttribute('data-app-key');
      // Aggregate across every product review, shared cache key with the home strip and the
      // cart page. The site-review bottomline counts only the ~64 reviews about the shop
      // itself, so the drawer disagreed with the rest of the site (Toby, 2026-09-24).
      var cacheKey = 'mrh-yotpo-agg-' + key;
      var show = function (d) {
        var score = Number(d.avg) || 0, total = Number(d.total) || 0;
        if (!total) return;
        yotpo.querySelector('[data-mr-yotpo-text]').textContent =
          score.toFixed(1) + ' from ' + total.toLocaleString('en-GB') + ' ' + (yotpo.getAttribute('data-suffix') || 'reviews');
        yotpo.hidden = false;
      };
      var cached = null;
      try { var raw = sessionStorage.getItem(cacheKey); if (raw) { cached = JSON.parse(raw); if (Date.now() - cached.t > 3600000) cached = null; } } catch (e) {}
      if (cached) show(cached.d);
      else if (key) {
        var api = 'https://api-cdn.yotpo.com/v1/reviews/' + encodeURIComponent(key) + '/filter.json';
        Promise.all([5, 4, 3, 2, 1].map(function (score) {
          return fetch(api, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ page: 1, per_page: 1, scores: [score] }) })
            .then(function (r) { return r.json(); })
            .then(function (j) { return j && j.response && j.response.pagination ? j.response.pagination.total : 0; });
        })).then(function (t) {
          var total = t.reduce(function (a, b) { return a + b; }, 0);
          if (!total) return;
          var d = { total: total, avg: Math.round(((5 * t[0] + 4 * t[1] + 3 * t[2] + 2 * t[3] + t[4]) / total) * 10) / 10 };
          try { sessionStorage.setItem(cacheKey, JSON.stringify({ t: Date.now(), d: d })); } catch (e) {}
          show(d);
        }).catch(function () {});
      }
    }
  }

  function render() {
    // A redraw asked for mid-render (e.g. the set-up fee reconciler changed the cart) must not be
    // dropped, or the drawer shows the cart as it was before that change.
    if (rendering) { renderAgain = true; return rendering; }
    root.classList.add('is-loading');
    rendering = fetch(window.location.pathname + '?section_id=' + encodeURIComponent(sectionId), { headers: { 'Accept': 'text/html' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-cart-drawer-content]');
        var current = root.querySelector('[data-cart-drawer-content]');
        if (fresh && current) current.innerHTML = fresh.innerHTML;
        enhance();
        settle();
        // Accelerated checkout (Shop Pay / Google Pay / PayPal) markup is re-rendered with the section; ask Shopify to re-hydrate it.
        if (window.Shopify && Shopify.PaymentButton && typeof Shopify.PaymentButton.init === 'function') Shopify.PaymentButton.init();
      })
      .catch(function () {})
      .then(function () {
        root.classList.remove('is-loading'); rendering = null;
        if (renderAgain) { renderAgain = false; return render(); }
      });
    return rendering;
  }

  // Right after an Itoris DPO add the section render (and /cart.js) can carry the new line with
  // a null title and a £0.00 price for a few seconds while the app finishes creating the
  // variant. Show that line as a skeleton, hide the totals, and re-render with back-off until
  // every line has a title and a price.
  function sane() {
    var items = root.querySelectorAll('[data-drawer-item]');
    for (var i = 0; i < items.length; i++) {
      var title = items[i].querySelector('.mr-drawer__item-title');
      var total = items[i].querySelector('.mr-drawer__line-total');
      var pence = total ? Math.round(parseFloat((total.textContent || '').replace(/[^0-9.]/g, '')) * 100) : NaN;
      var bad = !title || !title.textContent.trim() || isNaN(pence) || pence === 0;
      items[i].classList.toggle('is-pending', bad);
      if (bad) return false;
    }
    return true;
  }
  function settle() {
    if (retryTimer) { clearTimeout(retryTimer); retryTimer = null; }
    if (sane()) { root.classList.remove('is-pending'); retries = 0; return; }
    root.classList.add('is-pending');
    if (retries >= 4) { root.classList.remove('is-pending'); retries = 0; return; }
    retryTimer = setTimeout(function () { retries++; render(); }, [2500, 3500, 5000, 8000][retries]);
  }

  function open() {
    if (root.classList.contains('is-open')) return;
    lastFocus = document.activeElement;
    root.classList.add('is-open');
    root.setAttribute('aria-hidden', 'false');
    document.body.classList.add('mr-drawer-open');
    setTimeout(function () { var c = root.querySelector('.mr-drawer__close'); (c || panel).focus(); }, 60);
  }
  function close() {
    if (!root.classList.contains('is-open')) return;
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('mr-drawer-open');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function broadcast(cart) {
    selfUpdate = true;
    try { window.dispatchEvent(new CustomEvent('cartcount:update', { detail: cart })); } catch (e) {}
    selfUpdate = false;
  }

  function change(key, quantity, itemEl) {
    if (itemEl) itemEl.classList.add('is-busy');
    return fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (r) { return r.json(); })
      .then(function (cart) { broadcast(cart); return render(); })
      .catch(function () { if (itemEl) itemEl.classList.remove('is-busy'); });
  }

  /* Empty cart: the first tap arms the button, a second within 6s clears the cart */
  var clearTimer = null;
  function clearCart(btn) {
    var label = btn.querySelector('[data-drawer-clear-label]') || btn;
    if (!btn.classList.contains('is-armed')) {
      btn.classList.add('is-armed');
      label.textContent = btn.getAttribute('data-confirm-label') || 'Tap again to empty cart';
      clearTimeout(clearTimer);
      clearTimer = setTimeout(function () {
        btn.classList.remove('is-armed');
        label.textContent = btn.getAttribute('data-label') || 'Empty cart';
      }, 6000);
      return;
    }
    clearTimeout(clearTimer);
    btn.disabled = true;
    return fetch('/cart/clear.js', { method: 'POST', headers: { 'Accept': 'application/json' } })
      .then(function () { return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }); })
      .then(function (r) { return r.json(); })
      .then(function (cart) { broadcast(cart); return render(); })
      .catch(function () { btn.disabled = false; });
  }

  function addVariant(id, btn) {
    var label = btn.querySelector('.cart-addons__add-text');
    var errorEl = root.querySelector('[data-cart-addons-error]');
    btn.disabled = true; btn.classList.add('is-loading');
    if (label) label.textContent = 'Adding';
    if (errorEl) errorEl.hidden = true;
    return fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    }).then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error((res.d && (res.d.description || res.d.message)) || 'Could not add to cart');
        return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
      })
      .then(function (cart) { broadcast(cart); return render(); })
      .catch(function (err) {
        btn.disabled = false; btn.classList.remove('is-loading');
        if (label) label.textContent = btn.getAttribute('data-label') || 'Add';
        if (errorEl) { errorEl.textContent = err && err.message ? err.message : 'Could not add to cart.'; errorEl.hidden = false; }
      });
  }

  /* ---------- events ---------- */
  root.addEventListener('click', function (e) {
    var t = e.target;
    if (t.closest('[data-cart-drawer-close]')) { e.preventDefault(); close(); return; }
    var minus = t.closest('[data-drawer-qty-minus]');
    var plus = t.closest('[data-drawer-qty-plus]');
    var remove = t.closest('[data-drawer-remove]');
    var add = t.closest('[data-cart-addon-add]');
    var clear = t.closest('[data-drawer-clear]');
    if (clear) { e.preventDefault(); clearCart(clear); return; }
    if (minus || plus) {
      var wrap = t.closest('[data-drawer-qty]');
      var key = wrap.getAttribute('data-key');
      var qty = parseInt(wrap.getAttribute('data-qty'), 10) || 1;
      change(key, plus ? qty + 1 : Math.max(0, qty - 1), t.closest('[data-drawer-item]'));
      return;
    }
    if (remove) { change(remove.getAttribute('data-drawer-remove'), 0, t.closest('[data-drawer-item]')); return; }
    if (add) { e.preventDefault(); var vid = parseInt(add.getAttribute('data-variant-id'), 10); if (vid) addVariant(vid, add); }
  });
  window.addEventListener('keydown', function (e) { if (e.key === 'Escape' && root.classList.contains('is-open') && !document.body.classList.contains('mrcm-open')) close(); });
  // The "Edit configuration" modal (mr-configurator-modal.js) swapped a line: redraw in place
  window.addEventListener('mrcart:refresh', function () { if (root.classList.contains('is-open')) render(); });
  // Back/forward cache: the page is restored as it was, so the header count and an open drawer
  // can show a cart that changed on another page. Re-read it.
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { broadcast(cart); if (root.classList.contains('is-open')) render(); })
      .catch(function () {});
  });

  // Header cart icon opens the drawer (except on the cart page itself)
  if (openFromHeader && !isCartPage) {
    document.querySelectorAll('.site-header-cart--button').forEach(function (a) {
      a.addEventListener('click', function (e) {
        if (e.metaKey || e.ctrlKey || e.shiftKey) return;
        e.preventDefault();
        render().then(open);
      });
    });
  }

  // Any add-to-cart in the theme (PDP form, quick buy, cart-page add-ons) dispatches cartcount:update
  if (openOnAdd && !isCartPage) {
    window.addEventListener('cartcount:update', function (e) {
      // The set-up fee reconciler's own broadcast is not an add; it redraws via mrcart:refresh
      if (selfUpdate || (e.detail && e.detail._mrSetupFee)) return;
      render().then(open);
    });
    // Close Empire's slide-down banner as soon as it is inserted (it is hidden by CSS but traps focus)
    var header = document.querySelector('[data-site-header]');
    if (header && window.MutationObserver) {
      new MutationObserver(function (muts) {
        muts.forEach(function (m) {
          Array.prototype.forEach.call(m.addedNodes, function (n) {
            if (n.nodeType === 1 && n.matches('[data-atc-banner]')) {
              setTimeout(function () { var c = n.querySelector('[data-atc-banner-close]'); if (c) c.click(); }, 350);
            }
          });
        });
      }).observe(header, { childList: true });
    }
  }

  enhance();
})();
